import { RouterConfig } from '#/router';
import APP_CONFIG from '@/APP_CONFIG';
import { App } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';

export const statisticsRouter: RouterConfig = {
  path: '/eva',
  redirect: '/eva/index',
  component: () => import('@/components/ParentView.vue'),
  children: [
    {
      path: 'index',
      meta: {
        title: '专技人才测评报告',
      },
      component: () => import('@/views/eva/index.vue'),
    },
    {
      path: 'evaluate',
      meta: {
        title: '人才能力评估报告',
        icon: 'st_personnal_assessment',
      },
      component: () => import('@/views/eva/Evaluate.vue'),
    },
    {
      path: 'result',
      meta: {
        title: '个人成果情况',
        icon: 'st_result',
      },
      component: () => import('@/views/eva/Result.vue'),
    },
    {
      path: 'reward',
      meta: {
        title: '表彰奖励',
        icon: 'st_commend',
      },
      component: () => import('@/views/eva/Reward.vue'),
    },
    {
      path: 'edu',
      meta: {
        title: '继续教育',
        icon: 'st_edu',
      },
      component: () => import('@/views/eva/Edu.vue'),
    },
    {
      path: 'thesis',
      meta: {
        title: '发表论文',
        icon: 'st_paper',
      },
      component: () => import('@/views/eva/Thesis.vue'),
    },
    {
      path: 'book',
      meta: {
        title: '出版著作',
        icon: 'st_opus',
      },
      component: () => import('@/views/eva/Book.vue'),
    },

    {
      path: 'patent',
      meta: {
        title: '知识产权',
        icon: 'st_intellectual',
      },
      component: () => import('@/views/eva/Patent.vue'),
    },

    {
      path: 'project',
      meta: {
        title: '承担项目',
        icon: 'st_project',
      },
      component: () => import('@/views/eva/Project.vue'),
    },
    {
      path: 'year_check',
      meta: {
        title: '年度考核',
        icon: 'st_year_assessment',
      },
      component: () => import('@/views/eva/YearCheck.vue'),
    },
    {
      path: 'pay',
      meta: {
        title: '支付',
      },
      component: () => import('@/views/eva/Pay.vue'),
    },
    {
      path: 'pay_success',
      meta: {
        title: '我的订单',
      },
      component: () => import('@/views/eva/PaySuccess.vue'),
    },
    {
      path: 'pic',
      meta: {
        title: '专技人才测评报告',
      },
      component: () => import('@/views/eva/Pic.vue'),
    },
  ],
};
const certifyRouteRaw: Array<RouterConfig> = APP_CONFIG.SHOW_CERTIFY
  ? [
      {
        path: '/certify',
        meta: {
          title: '证书',
        },
        component: () => import('@/views/certify/Certify.vue'),
      },
      {
        path: '/certify-detail',
        meta: {
          title: '证书详情',
        },
        component: () => import('@/views/certify/CertifyDetail.vue'),
      },
    ]
  : [];
const routes: Array<RouterConfig> = [
  {
    path: '/',
    meta: {
      title: '个人信息',
    },
    component: () => import('@/views/user/Home.vue'),
  },
  {
    path: '/history',
    meta: {
      title: '历史信息',
    },
    component: () => import('@/views/history/History.vue'),
  },
  {
    path: '/bind',
    meta: {
      title: '绑定信息',
    },
    component: () => import('@/views/user/Bind.vue'),
  },
  {
    path: '/review',
    meta: {
      title: '查询开评评委会',
    },
    component: () => import('@/views/evaluation/Review.vue'),
  },
  {
    path: '/progress',
    meta: {
      title: '申报流程',
    },
    component: () => import('@/views/history/Progress.vue'),
  },
  {
    path: '/change-psd',
    meta: {
      title: '修改密码',
    },
    component: () => import('@/views/user/ChangePsd.vue'),
  },
  {
    path: '/report-tb',
    meta: {
      title: '申报表',
    },
    component: () => import('@/views/history/ReportTable.vue'),
  },
  {
    path: '/view',
    meta: {
      title: '申报信息',
    },
    component: () => import('@/views/user/View.vue'),
  },
  ...certifyRouteRaw,
  {
    path: '/order',
    meta: {
      title: '我的订单',
    },
    component: () => import('@/views/user/Order.vue'),
  },

  {
    path: '/qr',
    meta: {
      title: '证书',
    },
    component: () => import('@/views/user/Qr.vue'),
  },
  {
    path: '/register',
    meta: {
      title: '注册',
    },
    component: () => import('@/views/user/Register.vue'),
  },
  {
    path: '/survey',
    meta: {
      title: '注册',
    },
    component: () => import('@/views/survey/Survey.vue'),
  },
  {
    path: '/success',
    meta: {
      title: '注册',
    },
    component: () => import('@/views/survey/Success.vue'),
  },
  {
    path: '/complist',
    meta: {
      title: 'complist',
    },
    component: () => import('@/views/CompList.vue'),
  },

  {
    path: '/jury',
    meta: {
      title: '专技人才测评报告',
    },
    component: () => import('@/views/eva/Jury.vue'),
  },
  statisticsRouter,
  {
    path: '/:path(.*)*',
    component: () => import('@/views/NotFind.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export const installRouter = (app: App) => {
  app.use(router);
};

export default router;
